import './App.css';

function App() {
  return (
    <div className="App">
      <h2>Terms & Conditions</h2>
      <p>
        These terms and conditions apply to the Easy Reserve app (hereby referred to as "Application") for mobile devices that was created by Inicus Innovations Limited (hereby referred to as "Service Provider") as a Free service.
      </p>
      <p>
        Upon downloading or utilizing the Application, you are automatically agreeing to the following terms. It is strongly advised that you thoroughly read and understand these terms prior to using the Application. Unauthorized copying, modification of the Application, any part of the Application, or our trademarks is strictly prohibited. Any attempts to extract the source code of the Application, translate the Application into other languages, or create derivative versions are not permitted. All trademarks, copyrights, database rights, and other intellectual property rights related to the Application remain the property of the Service Provider.
      </p>
      <p>
        The Service Provider is dedicated to ensuring that the Application is as beneficial and efficient as possible. As such, they reserve the right to modify the Application or charge for their services at any time and for any reason. The Service Provider assures you that any charges for the Application or its services will be clearly communicated to you.
      </p>
      <p>
        The Application stores and processes personal data that you have provided to the Service Provider in order to provide the Service. It is your responsibility to maintain the security of your phone and access to the Application. The Service Provider strongly advises against jailbreaking or rooting your phone, which involves removing software restrictions and limitations imposed by the official operating system of your device. Such actions could expose your phone to malware, viruses, malicious programs, compromise your phone's security features, and may result in the Application not functioning correctly or at all.
      </p>
      <p>
        Please note that the Application utilizes third-party services that have their own Terms and Conditions. These include:
        <ul>
          <li>Google Play Services</li>
          <li>Firebase Crashlytics</li>
          <li>Mapbox</li>
        </ul>
      </p>
      <p>
        Please be aware that the Service Provider does not assume responsibility for certain aspects. Some functions of the Application require an active internet connection, which can be Wi-Fi or provided by your mobile network provider. The Service Provider cannot be held responsible if the Application does not function at full capacity due to lack of access to Wi-Fi or if you have exhausted your data allowance.
      </p>
      <p>
        If you are using the application outside of a Wi-Fi area, please be aware that your mobile network provider's agreement terms still apply. Consequently, you may incur charges from your mobile provider for data usage, including roaming charges. By using the application, you accept responsibility for any such charges. If you are not the bill payer, they assume you have permission from the bill payer.
      </p>
      <p>
        Similarly, the Service Provider cannot always assume responsibility for your usage of the application. For example, it is your responsibility to ensure that your device remains charged.
      </p>
      <p>
        While the Service Provider strives to ensure that the app is updated and accurate at all times, it relies on third parties to provide information and accepts no liability for losses caused by reliance on this data.
      </p>
      <p>
        The Service Provider may update or discontinue the Application at any time. If use is terminated, you must stop using and delete the Application.
      </p>
      <p>
        <strong>Changes to Terms:</strong> These Terms and Conditions may be updated. Please review this page regularly. Updates are effective upon posting.
      </p>
      <p>
        Effective Date: 2025-02-04
      </p>
      <p>
        Contact: inicustechnologies@gmail.com
      </p>

      <hr />

      <h2>Privacy Policy</h2>
      <p>
        This Privacy Policy outlines how the Easy Reserve application ("Application") collects, uses, and protects user data. The Application is developed by Inicus Innovations Limited ("Service Provider").
      </p>

      <h3>1. Information Collected</h3>
      <ul>
        <li>Personal Information: Name, email, reservation info.</li>
        <li>Device & Usage Data: OS, device info, crash logs.</li>
        <li>
          <strong>Location Data:</strong> We may collect location data to offer services like nearby restaurant discovery. This is done with your permission and only when the app is active. You can disable this in your device settings.
        </li>
      </ul>

      <h3>2. Third-Party Services</h3>
      <p>
        The app uses the following third-party services, which may also collect data:
        <ul>
          <li>Google Play Services</li>
          <li>Firebase (Authentication, Realtime Database, Crashlytics)</li>
          <li>Mapbox (Maps & Location features)</li>
        </ul>
      </p>

      <h3>3. Data Storage & Security</h3>
      <p>
        We securely store user data via Firebase and use security best practices. Users are responsible for keeping their devices secure.
      </p>

      <h3>4. Data Sharing</h3>
      <p>
        Data is not sold. It may be shared with third-party services only to support app functionality, or with legal authorities as required.
      </p>

      <h3>5. Children’s Privacy</h3>
      <p>
        We do not knowingly collect data from children under 13. Contact us if you believe we have unintentionally done so.
      </p>

      <h3>6. Updates</h3>
      <p>
        We may update this policy. Changes are posted on this page and take effect immediately.
      </p>

      <h3>7. Contact</h3>
      <p>
        For questions or concerns: inicustechnologies@gmail.com
      </p>
    </div>
  );
}

export default App;
